import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { rateCardActions } from "../../../../store/external/finance/rate-card.reducer";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
class RateCardTable extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            detailsView: false,
            employeeId: 0,
            userId: 0
        }
    }
    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractRateCard();
        }
    };

    componentDidMount() {
        this.props.getRateCard();
    }

    componentWillUnmount() {
        this.props.setDefaultRateCard();
        this.props.getRateCard(0, true);
    }

    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    resizePage = (value) => {
        const { getRateCard, resizeRateCardPage } = this.props;
        resizeRateCardPage(value);
        getRateCard();
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    applyFilter = (isApply) => {
        const { getRateCard, applyRateCardFilter } = this.props;
        applyRateCardFilter(isApply);
        getRateCard(0);
    }
    handleRowClick = (data) => {
       
    }
    handleCloseForm = () =>{
       
    }
    handleSelectedIndex = () =>{

    }

    render() {
        const { rateCard, getRateCard, sortRateCardItems, setRateCardColSearchStr, addRateCardFilter, removeRateCardFilter } = this.props;
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.FinanceRateCardDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.FinanceRateCardDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.FinanceRateCardDashboardRW])
        return (
            <DetailsDashboard 
            // Filter Propertiess
            data={rateCard.rateCardItems.TableFilterData} 
            translation={""} 
            addAction={addRateCardFilter} 
            removeAction={removeRateCardFilter} 
            applyAction={this.applyFilter}
            isCreateButtonHidden={true}
            isCustomColumns={true}
            customClassName={"cost-allocation"}
            //View Search Textbox
            viewSearchAction={this.displaySearchBox}

            //Customize Column
            firstList={null} 
            secondList={null} 
            defaultList={null} 
            saveAction={()=>{}}

            //Extract Button
            extractAction={(e) => this.onClickExtract(e)}

             //Access Type
                isReadOnly={isReadOnly}
                isReadAndExtractOnly={isReadAndExtractOnly}
                isReadAndWrite={isReadAndWrite}
            >
            {true ?
                <TablePagination  
                    key={TABLE_PAGINATION_KEY.rateCard}
                    classNameWrapper="overflow-auto"
                    columns={rateCard.rateCardItems.Headers}
                    pageList={rateCard.rateCardItems.Data}
                    pages={rateCard.rateCardItems.Pagination}
                    rowClickAction={(item) => {this.handleRowClick(item)}}
                    paginationAction={getRateCard}
                    onColumnClick={sortRateCardItems}
                    onColumnSearch={() => { getRateCard(0) }}
                    onColumnSearchChange={setRateCardColSearchStr}
                    isColSearchShow={this.state.displaySearch}
                    resizePage={this.resizePage}
                    totalPage={rateCard.rateCardItems.Pagination.TotalEntries}
                    hideStatusIcon={true}
                />
            : this.loading()}
        </DetailsDashboard>
        );
    }
}
export default withRouter(connect(
    state => {
        const { rateCard } = state;
        return {
            rateCard
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, rateCardActions),
        dispatch
    )
)(RateCardTable));